import { render, staticRenderFns } from "./SalesSettings.vue?vue&type=template&id=dda52194&"
import script from "./SalesSettings.vue?vue&type=script&lang=js&"
export * from "./SalesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports